import { useState, useEffect } from 'react';
import apiClient from '../config/api';

// Hook to handle async feature configuration loading
export const useFeatureConfig = () => {
    const [config, setConfig] = useState({
        qrCodeSupported: false, // Default value - only enabled when explicitly set
        loaded: false
    });

    useEffect(() => {
        const loadConfig = async () => {
            try {
                // Use the same apiClient pattern as other services
                const response = await apiClient.get('/api/config');
                
                setConfig({
                    qrCodeSupported: response.data.qrCodeSupported,
                    loaded: true
                });
            } catch (error) {
                console.error('useFeatureConfig: Failed to load config:', error);
                // Use defaults if loading fails
                setConfig({
                    qrCodeSupported: false,
                    loaded: true
                });
            }
        };

        loadConfig();
    }, []);
    return config;
};
